import React, { useState } from "react";
import OwlCarousel from "react-owl-carousel";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

// Helper to strip HTML tags from string
const stripHtml = (html) => html.replace(/<[^>]*>?/gm, "");

// Helper to truncate text by char limit
const truncateText = (text, limit) => {
  return text.length <= limit ? text : text.slice(0, limit);
};

// Static image array matching API order


const imageMap = [
  {
    image_black: "/assets/images/mist/vision-black-icon.png",
    image_white: "/assets/images/mist/vision-white-icon.png",
    backgroundImage: "/assets/images/mist/vision-box-highlight-grid.webp",
  },
  {
    image_black: "/assets/images/mist/mission-black-icon.png",
    image_white: "/assets/images/mist/mission-white-icon.png",
    backgroundImage: "/assets/images/mist/mission-box-highlight-grid.webp",
  },
  {
    image_black: "/assets/images/mist/value-black-icon.png",
    image_white: "/assets/images/mist/value-white-icon.png",
    backgroundImage: "/assets/images/mist/value-box-highlight-grid.webp",
  },
];

function BoxHighlightVisionMissionValue({
  principles,
  siteType,
  defaultHeadings = ["Vision:", "Mission:", "Values:"],
}) {
  const [showModal, setShowModal] = useState(false);
  const [selectedContent, setSelectedContent] = useState({});
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const CHAR_LIMIT = 90;

  if (!principles?.length || siteType !== "hospitals") return null;

  const handleReadMore = (data) => {
    setSelectedContent(data);
    setShowModal(true);
  };

  const renderContentBox = (data, index) => {
    const description = data?.description || "No Description Found";
    const plainText = stripHtml(description);
    const isTruncated = plainText.length > CHAR_LIMIT;
    const truncated = truncateText(plainText, CHAR_LIMIT);

    const htmlContent = isTruncated
      ? `${truncated}... <span class="fw-bold p-0 ml-1" style="cursor:pointer;">Read More</span>`
      : description;

    const isMobile = typeof window !== "undefined" && window.innerWidth < 768;


    const imageSrc = isMobile
      ? imageMap[index]?.image_white
      : hoveredIndex === index
        ? imageMap[index]?.image_white
        : imageMap[index]?.image_black;


    const backgroundImage = imageMap[index]?.backgroundImage;

    return (
      <div
        className={`f-box-style-2 boxhighlighted-mission-f-box-style-2 text-center my-4 ${isMobile ? "active" : ""}`}

        key={`content-${index}`}
        onMouseEnter={() => !isMobile && setHoveredIndex(index)}
        onMouseLeave={() => !isMobile && setHoveredIndex(null)}

      >
        <div
          className="f-box-inner div-bg-img b-radius-20"
          // style={{ backgroundImage: 'url("/assets/images/mist/vision-box-ighlight-grid.jpg")' }}
          style={{ backgroundImage: `url(${backgroundImage})` }}
        >
          <div className="feature-icon margin-bottom-15">
            {imageSrc ? (
              <img
                src={imageSrc}
                alt=""
                style={{ width: "40px", height: "40px" }}
              />
            ) : (
              <i className="bi bi-buildings theme-color"></i>
            )}
          </div>
          <div className="feature-content mb-3">
            <div className="feature-title">
              <h5 className="margin-bottom-5">
                {data?.heading || defaultHeadings[index]}
              </h5>
            </div>
            <p
              className="mb-0 text-center text-black"
              dangerouslySetInnerHTML={{ __html: htmlContent }}
              onClick={(e) => {
                if (e.target.innerText === "Read More") {
                  handleReadMore(data);
                }
              }}
            />
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <div className="container">
        {/* Desktop View */}
        <div className="home-intro-desktop mt-5">
          <div className="row">
            {principles.map((data, index) => (
              <div className="col-lg-4 pad-top-md-30" key={`desktop-${index}`}>
                {renderContentBox(data, index)}
              </div>
            ))}
          </div>
        </div>

        {/* Mobile View */}
        <div className="home-intro-mobile-view">
          <OwlCarousel
            className="service-main-wrapper"
            loop
            nav={false}
            dots={false}
            autoplay
            autoplayTimeout={2500}
            autoplayHoverPause
            smartSpeed={1000}
            margin={30}
            responsive={{ 0: { items: 1 } }}
          >
            {principles.map((data, index) => (
              <div key={`mobile-${index}`} className="item">
                {renderContentBox(data, index)}
              </div>
            ))}
          </OwlCarousel>
        </div>

        {/* Modal for full content */}
        <Modal show={showModal} onHide={() => setShowModal(false)} centered>
          <Modal.Header closeButton>
            <Modal.Title>{selectedContent?.heading || "Details"}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div
              dangerouslySetInnerHTML={{
                __html: selectedContent?.description || "No content available",
              }}
            />
          </Modal.Body>
          <Modal.Footer>
            <Button variant="btn btn-default" onClick={() => setShowModal(false)}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>

      </div>
    </>
  );
}

export default BoxHighlightVisionMissionValue;
